<template>
  <div class="list-group">
    <div v-for="article in selectableArticles" :key="article.id"
         class="list-group-item d-flex justify-content-between"
         :class="{active: article.selected, 'text-white': article.selected}">
      <div class="ml-1">
        <input type="checkbox" class="form-check-input form-control-sm px-1" v-model="article.selected"/>
        <cld-image :public-id="'' + article.product.imageId" height="40" class="mr-3"/>
      </div>
      <div class="d-flex flex-grow-1 justify-content-between">
        <div class="font-weight-bold">{{ article.product.name }}</div>
        <div class="flex-grow-1 text-right mr-3" v-if="!article.editingDates" @click="article.editingDates = true">
          {{ article.validFromDate | shortDate }}-{{ article.validUntilDate | shortDate }}
        </div>
        <ArticleValidDatesEditor v-if="article.editingDates" :article="article"
                                 @update="updateArticleDates(article, $event)"/>
      </div>
      <div class="h-100 align-content-center">
        <ArticleInSaleStatus :article="article" class="mr-2" @toggle="toggleInSale(article)"/>
      </div>
      <div>
        <input type="number" class="form-control form-control-sm"
               :ref="article.id + '_newPriceInput'"
               :value="article.grossPrice"
               @change="setArticlePrice(article, +$event.target.value)"/>
      </div>
    </div>
  </div>
</template>
<script>
import ArticleInSaleStatus from "@/components/shop/ArticleInSaleStatus";
import ArticleValidDatesEditor from "@/components/shop/ArticleValidDatesEditor";

export default {
  components: {ArticleValidDatesEditor, ArticleInSaleStatus},
  props: {
    articles: Array
  },
  data() {
    return {
      selectableArticles: []
    }
  },
  computed: {
    selectedArticles() {
      return this.selectableArticles.filter(a => a.selected)
    }
  },
  watch: {
    articles: {
      handler(newVal) {
        this.selectableArticles = newVal.map(a => {
          return {...a, selected: false, newPrice: 0, editingDates: false}
        })
      },
      immediate: true
    },
    selectedArticles(newVal) {
      this.$emit('select', newVal)
    }
  },
  methods: {
    setArticlePrice(article, price) {
      console.log(price)
      article.grossPrice = price
      article.newPrice = null
      this.$api.post(`/articles/${article.id}`, article, {
        params: {
          action: 'updateGrossPrice'
        }
      }).then(() => {
        this.showInfo(`${article.product.name} kostet nun ${price}`)
        this.$emit('update')
      }).catch(err => this.handleError(err))
    },
    toggleInSale(article) {
      console.log('toggleInSale(' + article.id + ')')
      article.inSale = !article.inSale
      this.$api.post(`/articles/${article.id}`, article, {
        params: {
          action: 'toggleInSale'
        }
      }).then(() => {
        this.showInfo(article.product.name + (!article.inSale ? ' wurde aus dem Verkauf genommen.' : ' ist jetzt im Verkauf.'))
        this.$emit('update')
      }).catch(err => this.handleError(err))
    },
    updateArticleDates(article, dates) {
      article.validFromDate = dates[0]
      article.validUntilDate = dates[1]
      this.$api.post(`/articles/${article.id}`, article, {
        params: {
          action: 'updateValidityDates'
        }
      }).then(() => {
        this.showInfo(article.product.name + ' hat neue Gültigkeitsdaten.')
        this.$emit('update')
      }).catch(err => this.handleError(err))
    },
  }
}
</script>
